import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=c361db4a&scoped=true&"
import script from "./columns.vue?vue&type=script&lang=js&"
export * from "./columns.vue?vue&type=script&lang=js&"
import style0 from "./columns.vue?vue&type=style&index=0&id=c361db4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c361db4a",
  null
  
)

export default component.exports